import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { Text, Heading } from '@homebotapp/hb-react-component-catalog'
import { SUCCEEDED } from '../../../../../../types/loadingStatus'
import { selectPmiDMRequestedStatus } from '../../../../../../store/slices/pmi'
import { selectSponsorshipFirstName } from '../../../../../../store/selectors/sponsorship'
import { selectCustomerFirstName } from '../../../../../../store/selectors/customerProfile'

export const MSG = defineMessages({
  remove: {
    id: 'Pmi.pmiDetailsText.canRemove',
    defaultMessage: 'How much you could save by removing PMI today.'
  },
  successTitle: {
    id: 'Pmi.success.message.title',
    defaultMessage: 'Keep an eye on your inbox'
  },
  customerSubtitle: {
    id: 'Pmi.estimated.success.message.subtitle.customer',
    defaultMessage: '{customer} will check to see if you can remove PMI.'
  },
  sponsorSubtitle: {
    id: 'Pmi.estimated.success.message.subtitle.sponsor',
    defaultMessage: '{sponsor} is a lender {customer} trusts and will check to see if you can remove PMI.'
  }
})

export const CanRemovePmiDetailsBody = () => {
  const intl = useIntl()
  const requestStatus = useSelector(selectPmiDMRequestedStatus)
  const customerFirstName = useSelector(selectCustomerFirstName)
  const sponsorFirstName = useSelector(selectSponsorshipFirstName)
  const firstName = sponsorFirstName ? sponsorFirstName : customerFirstName

  return requestStatus !== SUCCEEDED ? (
    <Text size='sm' mt='4' mb='8'>
      {intl.formatMessage(MSG.remove)}
    </Text>
  ) : (
    <>
      <Heading mt='4' as='h5' size='sm' textAlign='left' fontWeight='semibold'>
        {intl.formatMessage(MSG.successTitle)}
      </Heading>
      <Text mt='2' mb='8' size='sm'>
        {sponsorFirstName
          ? intl.formatMessage(MSG.sponsorSubtitle, {
              sponsor: firstName,
              customer: customerFirstName
            })
          : intl.formatMessage(MSG.customerSubtitle, {
              customer: firstName
            })}
      </Text>
    </>
  )
}
